export function initHeaderWidget($) {
  function moveHeaderWidget() {
    const $widget = $(".header .widget");
    const $search = $(".header-actions .searchform_wrap");
    const $originalParent = $(".header"); // change if needed
  
    if (window.innerWidth <= 1000) {
      // place widget right AFTER search form
      if (!$search.next().is(".widget")) {
        $widget.insertAfter($search);
      }
    } else {
      // move back to original parent
      if (!$originalParent.find(".widget").length) {
        $widget.appendTo($originalParent);
      }
    }
  }
  
  moveHeaderWidget();
  $(window).on("resize", moveHeaderWidget);
}
